import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  ISearchBudget,
  ISearchFilter,
  ISearchRequest,
  ISearchSingle,
  IStoreDataModel,
  IStoreDetailData,
} from "../models";
import { RootState } from "redux/store";
import { IValueLabel } from "utils/commonModels";

export interface SearchStoreState {
  storeList: IStoreDetailData[];
  byBudgetList: IStoreDetailData[];
  page: number;
  storeDetail: IStoreDetailData;
  searchFilter: ISearchFilter;
  isLoading: boolean;
  errorMsg: string;
}

const initialState: SearchStoreState = {
  storeList: [],
  byBudgetList: [],
  page: 0,
  storeDetail: {
    Id: "",
  Area: "",
  Budgets: {
    night: {
      min: 0,
      max: 0,
    },
    day: {
      min: 0,
      max: 0,
    },
  },
  Intro: "",
  Detail: "",
  BusinessHours: {
    monday: {
      lunch: null,
      dinner: null,
    },
    tuesday: {
      lunch: null,
      dinner: null,
    },
    wednesday: {
      lunch: null,
      dinner: null,
    },
    thursday: {
      lunch: null,
      dinner: null,
    },
    friday: {
      lunch: null,
      dinner: null,
    },
    saturday: {
      lunch: null,
      dinner: null,
    },
    sunday: {
      lunch: null,
      dinner: null,
    },
    closed_day: [],
  },
  ReviewCount: 0,
  EntityType: "",
  Genres: [],
  Points: {
    avg: 0,
    cooking: 0,
    atmosphere: 0,
    service: 0,
    cost: 0,
  },
  Images: [],
  Seats: 0,
  Conditions: [],
  Scenes: [],
  Name: "",
  PK: "",
  },
  searchFilter: {
    sort_code: 0,
    minBudget: 0,
    maxBudget: 0,
    conditions: [],
    genres: [],
    scenes: []
  },
  isLoading: false,
  errorMsg: "",
};

const searchStoreSlice = createSlice({
  name: "searchStore",
  initialState: initialState,
  reducers: {
    setSearchFilter(
      state: SearchStoreState,
      action: PayloadAction<ISearchFilter>
    ) {
      state.searchFilter = action.payload;
    },
    resetSearchFilter(state: SearchStoreState) {
      state.searchFilter = initialState.searchFilter;
    },
    searchStore(
      state: SearchStoreState,
      action: PayloadAction<ISearchRequest>
    ) {
      state.isLoading = true;
    },
    getStoresSuccess(
      state: SearchStoreState,
      action: PayloadAction<IStoreDetailData[]>
    ) {
      state.isLoading = false;
      state.storeList = action.payload;
    },
    fetchDataFailed(state: SearchStoreState, action: PayloadAction<string>) {
      state.isLoading = false;
      state.errorMsg = action.payload;
    },
    setStoreDetail(
      state: SearchStoreState,
      action: PayloadAction<IStoreDetailData>
    ) {
      state.storeDetail = action.payload;
    },
    searchByBudget(
      state: SearchStoreState,
      action: PayloadAction<ISearchBudget>
    ) {
      state.isLoading = true;
    },
    clearBudgetStore(
      state: SearchStoreState,
    ) {
      state.byBudgetList = [];
      state.searchFilter.maxBudget = 0;
      state.searchFilter.minBudget = 0;
    },
    getByBudgetSuccess(
      state: SearchStoreState,
      action: PayloadAction<IStoreDetailData[]>
    ) {
      state.isLoading = false;
      state.byBudgetList = action.payload;
    },
    searchSingle(
      state: SearchStoreState,
      action: PayloadAction<ISearchSingle>
    ) {
      state.isLoading = true;
    },
    setSingleCondition(state: SearchStoreState, action: PayloadAction<string>) {
      state.searchFilter.conditions = [action.payload];
    },
    setSingleGenre(state: SearchStoreState, action: PayloadAction<string>) {
      state.searchFilter.genres = [action.payload];
    },
    setSingleScene(state: SearchStoreState, action: PayloadAction<string>) {
      state.searchFilter.scenes = [action.payload];
    },
    setAreaFilter(state: SearchStoreState, action: PayloadAction<IValueLabel<string>>) {
      state.searchFilter.area = action.payload;
    },
    resetFilter(state: SearchStoreState) {
      state.searchFilter = initialState.searchFilter;
    },
  },
});

export const searchStoreActions = searchStoreSlice.actions;

export const selectLoading = (state: RootState) => state.searchStore.isLoading;
export const selectStores = (state: RootState) => state.searchStore.storeList;
export const selectStoreDetail = (state: RootState) => state.searchStore.storeDetail;
export const selectByBudgetStores = (state: RootState) => state.searchStore.byBudgetList;
export const selectFilter = (state: RootState) =>
  state.searchStore.searchFilter;

const searchStoreReducer = searchStoreSlice.reducer;
export default searchStoreReducer;
